module.exports = __webpack_public_path__ + "media/images/video/yogasix-go-logo-9b71d34a38c84fb9bdfb2330850ca54b.png";